import React, { Component } from 'react';
import GoogleApiComponent from './utils/GoogleApiComponent';
import GoogleMap from './GoogleMap';
import Pin from './Pin';

import { POINT_CONVERSION_COMPRESSED } from 'constants';

//distance formula from
//https://www.movable-type.co.uk/scripts/latlong.html
const EARTHS_RADIUS = 6371e3; // meters
const MAX_DIST = 70.0; //meters

const rad = x => (x * Math.PI) / 180.0;

const toFeet = dm => dm / 0.3048;

class Map extends Component {
  state = {
    dotLocation: {},
  };

  isPinActive = id => this.props.activeStopId === id;
  isPinVisited = id => this.props.visitedStopIds.includes(id);

  setDefaultActivePin = () => {
    let hss = this.props.markers.filter(marker =>
      marker.title.match(/Henry Street Settlement/g)
    )[0];
    this.props.handleMarkerClicked(null, hss.id);
  };

  setDotLocation = dotLocation => {
    this.setState(
      { dotLocation: dotLocation },
      this.findClosestPin(dotLocation)
    );
  };

  findClosestPin = (dotLocation, maxDist = MAX_DIST) => {
    const { markers } = this.props;
    let lng1 = rad(dotLocation.lng);
    let lat1 = rad(dotLocation.lat);

    let minDist = maxDist;
    let closestStopId = -1;

    markers.map((marker, index) => {
      const { lat, lng } = marker.map_data;

      let lng2 = rad(lng);
      let lat2 = rad(lat);

      let x = (lng2 - lng1) * Math.cos((lat1 + lat2) / 2);
      let y = lat2 - lat1;
      let dist = Math.sqrt(x * x + y * y) * EARTHS_RADIUS;

      minDist = Math.min(minDist, dist);
      if (minDist === dist) {
        closestStopId = parseInt(marker.id);
      }
    });

    if (
      parseInt(this.props.activeStopId) !== closestStopId &&
      closestStopId !== -1
    ) {
      console.log('found it', parseInt(this.props.activeStopId), closestStopId);
      this.props.handleOpenTourStopByDistance(closestStopId);
    } else if (!this.props.firstStopLoaded) {
      console.log('keep looking');
      this.findClosestPin(dotLocation, (minDist += 10.0));
    }
  };

  render() {
    const style = {
      width: '100vw',
      height: '100vh',
    };
    const {
      loaded,
      markers,
      Maps,
      handleMarkerClicked,
      activeStopId,
      visitedStopIds,
      hasBeenOnboarded,
      isMobileDevice,
      isTransitioningBetweenStops,
      stopSelectionMethod,
    } = this.props;

    if (!loaded) {
      return <div style={style}>Loading...</div>;
    }
    return (
      <div id="map-div" style={style}>
        <GoogleMap
          Maps={Maps}
          markers={markers}
          isMobileDevice={isMobileDevice}
          hasBeenOnboarded={hasBeenOnboarded}
          shouldRequestLocation={hasBeenOnboarded && isMobileDevice}
          setDefaultActivePin={this.setDefaultActivePin}
          getDotLocationForMap={this.setDotLocation}
          stopSelectionMethod={stopSelectionMethod}
          handleSetSelectionMethod={this.props.handleSetSelectionMethod}
        >
          {hasBeenOnboarded &&
            markers.map((marker, index) => (
              <Pin
                id={marker.id}
                title={marker.title}
                isActive={this.isPinActive(marker.id)}
                isVisited={this.isPinVisited(marker.id)}
                handleMarkerClicked={handleMarkerClicked}
                isTransitioningBetweenStops={isTransitioningBetweenStops}
                key={marker.map_data.address}
                type={marker.tour_stop_type}
                {...marker.map_data}
                hasBeenOnboarded
                index={index}
              />
            ))}
        </GoogleMap>
      </div>
    );
  }
}

export default GoogleApiComponent({
  apiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY,
})(Map);



// WEBPACK FOOTER //
// ./src/components/tour/map/Map.js